BaseController = App.loadClass 'core::Angular/UsernameDropdown/BaseController'

class exports.BackgroundController extends BaseController
    constructor: (@scope, @transitions, @modalInstance, @repo, user, options) ->
        super(@scope, @transitions, @modalInstance, @repo)

        @scope.title = 'Edit Background'
        @scope.user = user
        @scope.areas_of_expertise = _.chunk(options.expertise, 2)
        @scope.professions = options.professions
        @scope.toggleCheckBox = @toggleCheckBox


    save: () =>
        @scope.setAlert({ msg: 'Saving Background...', type: 'info' })

        # Lets remove the empty string
        @scope.user.expertise_ids = _.filter @scope.user.expertise_ids, (id) =>
            return id isnt ''

        @repo.saveBackground(@scope.user).then (response) =>
            jsr = response.data
            @closeWithAlert(jsr.status, jsr.data)


    toggleCheckBox: (id) =>
        index = @scope.user.expertise_ids.indexOf(id)
        if index is -1
            @scope.user.expertise_ids.push id
        else
            @scope.user.expertise_ids.splice index, 1




